<template>
  <div class="lineup-list">
    <!-- 教练信息 -->
    <div class="coaches">
      <div class="coachesInfo" v-if="props.type === 'hostTeamMatchLineupList'">
        <div class="coach" >


          <div class="coach-info">
            <a-image :width="48" :height="48" :src="props.data.hostCoachPic || ''" fallback="/src/assets/imgs/default-head-1.webp"/>
            <div>
              <div class="coach-name">{{props.data.hostCoachName}}</div>
              <div class="formation">执教胜率{{props.data.hostTeamWinRate}}%</div>
            </div>
          </div>
          <div class="money">
            <p>球员总身价</p>
            <p>{{props.data.hostMarketValue}}</p>
          </div>
        </div>
      </div>



      <div class="coachesInfo" v-else>
        <div class="coach" >
          <div class="coach-info">
            <a-image :width="48" :height="48" :src="props.data.guestCoachPic || ''" fallback="/src/assets/imgs/default-head-1.webp"/>

            <div>
              <div class="coach-name">{{props.data.guestCoachName}}</div>
              <div class="formation">执教胜率{{props.data.guestTeamWinRate}}%</div>
            </div>
          </div>

          <div class="money">
            <p>球员总身价</p>
            <p>{{ props.data.guestMarketValue }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="players-wrapper">


      <!--    首发  -->
      <div class="team-list">
        <div class="title rollCall">首发名单</div>
        <div v-for="player in props.firstData[type]"
             :key="player.id"
             class="player-item">
          <div class="player-info">
            <a-image :width="24" :height="24" :src="player.picUrl || ''" fallback="/src/assets/imgs/default-head-1.webp"/>

            <span class="player-number">{{ player.shirtNumber }}</span>
            <div class="player-name">
              <p>
                <span style="margin-right: 6px;margin-bottom: 3px;">{{ player.playerName }}</span>
                <HEvent :playerName="player.playerName" :eventList="firstEventList" />

              </p>
              <p class="resetTypeName" v-if="(player.downTimeList && player.downTimeList.length) || (player.upTimeList && player.upTimeList.length)">
                <img src='@assets/icons/score/substitution.webp' alt="">
                <span>{{ hostSubstitution(player, type) }}</span>
              </p>
            </div>
          </div>

          <div class="player-status">
            <div class="player-rating" v-if="player.rating">{{ player.rating }}</div>
          </div>
        </div>
      </div>

      <!--    替补  -->

      <div class="team-list">
        <div class="title rollCall">替补名单</div>
        <div v-for="player in props.downData[type]"
             :key="player.id"
             class="player-item">
          <div class="player-info">
            <a-image :width="24" :height="24" :src="player.picUrl || ''" fallback="/src/assets/imgs/default-head-1.webp"/>

            <span class="player-number">{{ player.shirtNumber }}</span>
            <div class="player-name">
              <p>
                <span style="margin-right: 6px;margin-bottom: 3px;">{{ player.playerName }}</span>
                <HEvent :playerName="player.playerName" :eventList="downEventList" />

              </p>
              <p class="resetTypeName" v-if="(player.downTimeList && player.downTimeList.length) || (player.upTimeList && player.upTimeList.length)">
                <img src='@assets/icons/score/substitution.webp' alt="">
                <span>{{ hostSubstitution(player, type) }}</span>
              </p>
            </div>
          </div>

          <div class="player-status">
            <div class="player-rating" v-if="player.rating">{{ player.rating }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, h, defineProps } from "vue";
import {eventLegendIcon} from "@/views/live-detail/footballComponents/eventLegendStatus";

interface PlayerEvent {
  type: string;
  icon: string;
}

interface Player {
  id: number;
  number: number;
  name: string;
  avatar: string;
  rating: string;
  events?: PlayerEvent[];
}

const props = defineProps<{
  data: any
  firstData: any
  downData: any
  type: string
}>()

const eventListKey = computed(() => (props.type === 'hostTeamMatchLineupList' ? 'hostEventList' : 'guestEventList'))
const firstEventList = computed(() => (Array.isArray(props.firstData?.[eventListKey.value]) ? props.firstData[eventListKey.value] : []))
const downEventList = computed(() => (Array.isArray(props.downData?.[eventListKey.value]) ? props.downData[eventListKey.value] : []))

const HEvent = ({ playerName = '', eventList = [] }: any) => {
  if (!playerName) return h('span')
  if (!Array.isArray(eventList) || !eventList.length) return h('span')

  const findData = eventList.filter((item: any) => item.typeName !== '换人' && item.playerName === playerName)
  if (!findData.length) return h('span')

  const imgInfo = eventLegendIcon[findData[0].typeName]
  if (!imgInfo?.src) return h('span')
  return h('img', { src: imgInfo.src, alt: findData[0].typeName || 'event' })
}

const hostSubstitution = (item: any, key: string) => {
  const starters = Array.isArray(props.firstData?.[key]) ? props.firstData[key] : []
  const subs = Array.isArray(props.downData?.[key]) ? props.downData[key] : []

  if (Array.isArray(item?.upTimeList) && item.upTimeList.length) {
    const minuteIndex = item.upTimeList[0]
    const replaced = starters.find((p: any) => Array.isArray(p?.downTimeList) && p.downTimeList[0] === minuteIndex)
    return replaced?.playerName || ''
  }

  if (Array.isArray(item?.downTimeList) && item.downTimeList.length) {
    const minuteIndex = item.downTimeList[0]
    const replacement = subs.find((p: any) => Array.isArray(p?.upTimeList) && p.upTimeList[0] === minuteIndex)
    return replacement?.playerName || ''
  }

  return ''
}

</script>

<style scoped lang="scss">
.lineup-list {
  background: $bg-white;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid $border-color;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);

  .coaches {

    margin: 16px;
    padding: 12px;
    border-radius: 12px;
    background: $bg-stripe;
    border: 1px solid $border-light;
    .coach {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .coach-info {
        display: flex;
        align-items: center;
        & > div {
          margin-left: 4px;
          .coach-name {
            font-size: 14px;
            margin-bottom: 4px;
            color: $text-dark;
            font-weight: 600;
          }
          .formation {
            font-size: 12px;
            color: $text-secondary;
          }
        }
      }
      .money {
        text-align: center;
        font-weight: 400;
        font-size: 12px;
        color: $text-secondary;

        p:last-child {
          margin-top: 2px;
          color: $text-dark;
          font-weight: 700;
        }
      }
    }
  }

  .list-header {
    padding: 12px 0;
    text-align: center;

    background-repeat: no-repeat;

    .title {
      height: 30px;
      line-height: 30px;
      font-size: 14px;
      color: $text-dark;
      position: relative;
      background-image: url("@assets/icons/score/rollCall.webp");
      background-size: 100% 100%;


      &::before {
        left: -30px;
      }

      &::after {
        right: -30px;
      }
    }
  }

  .players-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 0 16px 16px;
    background: transparent;
  }

  .team-list {
    flex: 1;
    background: $bg-white;
    border: 1px solid $border-color;
    border-radius: 12px;
    overflow: hidden;
    .rollCall {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      color: $color-primary;
      background: rgba($color-primary, 0.12);
      border-bottom: 1px solid rgba($color-primary, 0.16);
      font-weight: 700;
    }
  }

  .player-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 14px;
    border-bottom: 1px solid $border-lighter;

    &:last-child {
      border-bottom: none;
    }

    .player-info {
      display: flex;
      align-items: center;
      gap: 8px;
      flex: 1;

      .player-avatar {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: #f0f0f0;
      }

      .player-number {
        min-width: 20px;
        color: $text-secondary;
        font-size: 12px;
        font-weight: 700;

      }

      .player-name {
        font-size: 14px;
        color: $text-dark;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        p.resetTypeName {
          span {
            color: $text-secondary !important;
          }
        }

        p {
          display: flex;
          align-items: center;

          span {
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 12px;
            color: $text-dark;
          }

          img {
            width: 12px;
            height: 12px;
            margin-right: 5px;
          }
        }
      }
    }

    .player-status {
      display: flex;
      align-items: center;
      gap: 8px;

      .player-events {
        display: flex;
        gap: 4px;

        .event-icon {
          width: 16px;
          height: 16px;
        }
      }

      .player-rating {
        min-width: 36px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background: $color-primary;
        color: $text-white;
        border-radius: 10px;
        font-size: 12px;
        font-weight: 700;
      }
    }
  }
}
</style>
